module.exports = __webpack_public_path__ + "img/catalina-high-angle.7609645a.png";